import { translate } from "../../../../config/localisation";
import { Box, Tab, Tabs, Typography, Paper, Button } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import UserDetail from "./UserDetail";
import TaskDetails from './TaskDetails';
import AnnotationDetails from './AnnotationDetails';
import QueuedTasksDetails from './QueuedTasksDetails';
import AddUserDialog from "../../component/common/AddUserDialog";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={2}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const DashBoard = () => {
    const [tabValue, setTabValue] = useState(0);
    // Пользователи заводятся на странице организации, но искать эту кнопку идут
    // в раздел «Админ». Дублируем её здесь, во вкладке пользователей.
    const [addUserOpen, setAddUserOpen] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const loggedInUserData = useSelector((state) => state.fetchLoggedInUserData.data);
    const orgId = loggedInUserData?.organization?.id;

    const handleTabChange = (e, v) => {
        setTabValue(v)
    }

    return (
      
        < >
            <Box>
                <Tabs 
                    value={tabValue} 
                    onChange={handleTabChange} 
                    aria-label="admin-tabs" 
                    variant='scrollable' 
                    scrollButtons='auto'
                    sx={{ 
                        '& .MuiTab-root': { fontSize: 17, fontWeight: '700', marginRight: '32px' },
                        padding:"20px"
                    }}>
                    <Tab label={translate("Task Details")}/>
                    <Tab label={translate("Annotation Details")}/>
                    <Tab label={translate("User Details")}/>
                    <Tab label={translate("Queued Tasks Status")}/>
                </Tabs>
            </Box>
            <Box sx={{ p: 1}}>
                <TabPanel value={tabValue} index={0}>
                <Paper variant="outlined" sx={{ borderRadius: "5px", backgroundColor: 'ButtonHighlight', padding: '16px'}}>
                    <TaskDetails  />  
                </Paper>
                </TabPanel> 
                <TabPanel value={tabValue} index={1}>
                    <Paper variant="outlined" sx={{ borderRadius: "5px", backgroundColor: 'ButtonHighlight', padding: '16px'}}>
                        <AnnotationDetails  />  
                    </Paper>
                </TabPanel> 
                <TabPanel value={tabValue} index={2}>
                    <Box sx={{ mb: 2 }}>
                        <Button
                            variant="contained"
                            onClick={() => setAddUserOpen(true)}
                        >
                            {translate("Add User")}
                        </Button>
                    </Box>
                    <AddUserDialog
                        open={addUserOpen}
                        onClose={() => setAddUserOpen(false)}
                        orgId={orgId}
                        onSuccess={() => setReloadKey((k) => k + 1)}
                    />
                    <Paper variant="outlined" sx={{ borderRadius: "5px", backgroundColor: 'ButtonHighlight'}}>
                        <UserDetail key={reloadKey} />
                    </Paper>
                </TabPanel>
                <TabPanel value={tabValue} index={3}>
                    <Paper variant="outlined" sx={{ borderRadius: "5px", backgroundColor: 'ButtonHighlight'}}>
                        <QueuedTasksDetails  /> 
                    </Paper> 
                </TabPanel> 
            </Box>
        </>
       
    )
}

export default DashBoard
